import { useState, useEffect } from "react";
import API from "@/lib/api";
import { MessageSquare, Loader2, Search } from "lucide-react";

const STATUS_BADGE = { new: "bg-blue-100 text-blue-700", open: "bg-amber-100 text-amber-700", resolved: "bg-green-100 text-green-700", closed: "bg-gray-100 text-gray-600" };

export default function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { API.get("/admin/enquiries").then(r => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-6" data-testid="admin-enquiries">
      <div className="flex items-center gap-3">
        <MessageSquare className="w-6 h-6 text-[#008A99]" />
        <div><h1 className="text-2xl font-bold text-gray-900">Enquiries</h1><p className="text-sm text-gray-500">{items.length} enquiries received</p></div>
      </div>
      {loading ? <div className="text-center py-8"><Loader2 className="w-6 h-6 animate-spin text-[#008A99] mx-auto" /></div> : (
        <div className="bg-white border rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="bg-gray-50 border-b"><th className="px-4 py-3 text-left text-xs font-semibold text-gray-500">Customer</th><th className="px-4 py-3 text-left text-xs font-semibold text-gray-500">Product</th><th className="px-4 py-3 text-left text-xs font-semibold text-gray-500">Message</th><th className="px-4 py-3 text-left text-xs font-semibold text-gray-500">Date</th></tr></thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id} className="border-b last:border-0 hover:bg-gray-50">
                  <td className="px-4 py-3"><div className="font-medium">{item.user_name || "—"}</div><div className="text-xs text-gray-400">{item.user_mobile}</div></td>
                  <td className="px-4 py-3 text-gray-600">{item.product_code}</td>
                  <td className="px-4 py-3 text-gray-600 max-w-xs truncate">{item.message}</td>
                  <td className="px-4 py-3 text-gray-400 text-xs">{new Date(item.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={4} className="text-center py-8 text-gray-400">No enquiries yet</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
